import {useWeb3} from "../../provider/web3_provider";
import {useSendFn} from "../../utils/web3_send";
import {useCallback} from "react";
import BigNumber from "bignumber.js";
import {HttpServer} from "../../net/http_server";

export const useCapitaStakeDeposit = () => {
    const {contrcts} = useWeb3();
    const handleSendFn = useSendFn(contrcts.stakeAddress);
    const handleDeposit = useCallback(async (amount:BigNumber) => {
        let method = contrcts.stakeContract.methods.deposit(amount.toFixed());
        let data = await handleSendFn(method);
        return data.transactionHash;
    }, [contrcts]);
    return [handleDeposit]
}


export const useClaim= () => {
    const {contrcts, web3} = useWeb3();
    const handleSendFn = useSendFn(contrcts.stakeAddress);
    const handleUnStake = useCallback(async (data: any) => {

        let {amount, v, r, s, deadline, currency} = data;
        console.log(amount.toString())
        let method = contrcts.stakeContract.methods.claim(amount.toString(), currency, deadline, v, r, s)
        console.log(method)
        let txHash = await handleSendFn(method);
        return txHash.transactionHash
    }, [
        contrcts,
        HttpServer.account,
        web3
    ])
    return [handleUnStake]
}
